import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { ResourceFactMappingPatternEntry } from "@app/models/rest/resource-fact-mapping-pattern-entry";

@Injectable({
  providedIn: "root"
})
export class ResourceFactMappingPatternEntryRestService extends HateoasResourceOperation<ResourceFactMappingPatternEntry> {
  constructor() {
    super(ResourceFactMappingPatternEntry);
  }
}
